import { compose, strictEq } from 'spark-util/fpUtils';
import { pluck } from 'spark-util/objects';

export const keys = {
    space: ' ',
    enter: 'Enter'
};

export const keyListener = key => handler => event =>
    event.key === key && handler && handler(event);

//Not required to do for all keys, but the most common ones will probably have helpers
export const onSpace = keyListener(keys.space);
export const onEnter = keyListener(keys.enter);

// isKey :: String key -> Event e -> Bool
const isKey = key => compose(strictEq(key), pluck('key'));

export const isBackspace = isKey('Backspace');
export const isEnter = isKey('Enter');
